import { FormGroup, Validators, FormControl } from '@angular/forms';
import { BaseModel, IBaseModel } from './base.model';

export interface IMaestroModel extends IBaseModel {
    nombre: string;
    activo: boolean;
    id_inactivado_por: number;
    cod_inactivado_por: string;
    fecha_inactivacion: Date
}


export class MaestroModel extends BaseModel {

    private _nombre: string;
    private _activo: boolean;
    private _idInactivadoPor: number;
    private _codInactivadoPor: string;
    private _fechaInactivacion: Date;

    constructor() {
        super();
        this._activo = true;
    }

    public set nombre( nombre: string ) { this._nombre = nombre };
    public get nombre(): string { return this._nombre };

    public set activo( activo: boolean ) { this._activo = activo };
    public get activo(): boolean { return this._activo };

    public set idInactivadoPor( idInactivadoPor: number ) { this._idInactivadoPor = idInactivadoPor };
    public get idInactivadoPor(): number { return this._idInactivadoPor };

    public set codInactivadoPor( codInactivadoPor: string ) { this._codInactivadoPor = codInactivadoPor };
    public get codInactivadoPor(): string { return this._codInactivadoPor };

    public set fechaInactivacion( fechaInactivacion: Date ) { this._fechaInactivacion = fechaInactivacion };
    public get fechaInactivacion(): Date { return this._fechaInactivacion };

    override async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        this._nombre = objeto.nombre;
        this._activo = objeto.activo;
        this._idInactivadoPor = objeto.id_inactivado_por;
        this._codInactivadoPor = objeto.inactivado_por?.codigo;
        this._fechaInactivacion = objeto.fecha_inactivacion ? new Date(objeto.fecha_inactivacion): objeto.fecha_inactivacion;
    }

    override async actualizarDatos( objeto: Record<string, any> ) {
        await super.actualizarDatos( objeto );
        this._nombre = objeto.nombre;
        this._activo = objeto.activo;
        this._idInactivadoPor = objeto.id_inactivado_por;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("nombre", new FormControl(this._nombre, Validators.required));
        fg.addControl("activo", new FormControl(this._activo));
        fg.addControl("id_inactivado_por", new FormControl(this._idInactivadoPor));
        fg.addControl("cod_inactivado_por", new FormControl(this._codInactivadoPor));
        fg.addControl("fecha_inactivacion", new FormControl({value: this._fechaInactivacion, disabled: true}));
        return fg;
    }

}